import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
    attendanceHeatMap: [],
    attendanceHeatMapChild: [],
    isLoadingAttendanceHeatMap: true,
    isLoadingAttendanceHeatMapChild: true,
    attendanceHeatMapXLabels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    attendanceHeatMapYLabels: [],
    attendanceHeatMapChart: [],
    attendanceHeatMapLabelID: '',
    hourlySpread: [],
    hourlySpreadChild: [],
    isLoadingHourlySpread: true,
    isLoadingHourlySpreadChild: true,
    hourlySpreadBarChart: [],
    hourlySpreadChart: [],
    hourlySpreadChildYLabels: [],
    hourlySpreadChildXLabels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, "Total Hrs"],
    topProductive: [],
    isLoadingTopProductive: true,
    leastProductive: [],
    isLoadingLeastProductive: true,
    utilization: [],
    isLoadingUtilization: true,

}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SUCCESS_ATTENDANCE_HEATMAP:
            const array = action.data.map((value, i) => {
                return {
                    id: value.month,
                    month:value.month.split(" ")[0],
                    year:parseInt(value.month.split(" ")[1])
                };
            });
            const child = action.data.map((value, i) => {
                return {
                    id: value.month, department: value.department, departmentID: value.departmentID
                };
            });
            var monthNames = {
                "January": 1,
                "February": 2,
                "March": 3,
                "April": 4,
                "May": 5,
                "June": 6,
                "July": 7,
                "August": 8,
                "September": 9,
                "October": 10,
                "November": 11,
                "December": 12
              };
            const month = array.filter((ele, ind) => ind === array.findIndex(elem => elem.id === ele.id)).sort(function(a, b) {
               return new Date("1 " +a.id)-new Date("1 " +b.id);
              });
            const list = child.filter((ele, ind) => ind === child.findIndex(elem => elem.departmentID === ele.departmentID && elem.id === ele.id));
          if (month.length > 0) {
                return {
                    ...state,
                    attendanceHeatMap: month.map(i => ({
                        ...i,
                        child: list.filter(value => value.id == i.id),
                       
                    })),
                    attendanceHeatMapChart: action.data.attendanceHeatMapChild,
                    isLoadingAttendanceHeatMap: false,
                }
            } else {
                return {
                    ...state,
                    attendanceHeatMap: [],
                    attendanceHeatMapChart: action.data.attendanceHeatMapChild,
                    isLoadingAttendanceHeatMapChild: false,
                    isLoadingAttendanceHeatMap: false,
                }
            }

        case types.FAILED_ATTENDANCE_HEATMAP:
            return {
                ...state,
                attendanceHeatMap: [],
                isLoadingAttendanceHeatMap: false,
                isLoadingAttendanceHeatMapChild: false,
            }
        case types.SUCCESS_HOURLY_SPREAD:
            if (action.data.length > 0) {
                const data = action.data.map((value, i) => {
                    return { id: value.userID, name: value.username };
                });
                return {
                    ...state,
                    isLoadingHourlySpread: false,
                    hourlySpread: data,
                }
            } else {
                return {
                    ...state,
                    hourlySpread: [],
                    isLoadingHourlySpreadChild: false,
                }
            }
        case types.FAILED_HOURLY_SPREAD:
            return {
                ...state,
                hourlySpread: [],
                isLoadingHourlySpread: false,
                isLoadingHourlySpreadChild: false,
            }

        case types.SUCCESS_HOURLY_SPREAD_CHILD:

            function conversion(mins) {
                let hrs = Math.floor(mins / 60);
                let min = (mins % 60);
                hrs = hrs < 10 ? '0' + hrs : hrs;
                min = min < 10 ? '0' + min : min;
                return `${hrs}.${min}`;
            }
           // console.log("ss", action.data.chartDataDate)
            return {
                ...state,
                hourlySpreadChild: action.data.chartDataDate.map(i => {
                    // console.log("ssso",
                    //     // parseFloat(moment((i.hour0).replace(".", ":"), "hh:mm").format("mm"))
                    //     moment.duration(moment("00:50", "HH:mm").format("HH:mm:ss")).asMinutes()
                        //  + moment("00:50", "hh:mm").asMinutes())
                        // + moment((i.hour2).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour3).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour4).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour5).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour6).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour7).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour8).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour9).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour10).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour11).replace(".", ":"), "hh:mm").format("mm")
                        // + moment((i.hour12).replace(".", ":"), "hh:mm").format("mm")
                        // + parseFloat(moment((i.hour13).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour14).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour15).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour16).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour17).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour18).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour19).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour20).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour21).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour22).replace(".", ":"), "hh:mm").format("mm"))
                        // + parseFloat(moment((i.hour23).replace(".", ":"), "hh:mm").format("mm"))
           //         )

                    var total =
                        moment.duration(moment((i.hour0).replace(".", ":"), "HH:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour1).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour2).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour3).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour4).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour5).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour6).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour7).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour8).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour9).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour10).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour11).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour12).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour13).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour14).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour15).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour16).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour17).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour18).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour19).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour20).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour21).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour22).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                        +  moment.duration(moment((i.hour23).replace(".", ":"), "hh:mm").format("HH:mm:ss")).asMinutes()
                   
                    return [i.hour0, i.hour1, i.hour2, i.hour3, i.hour4, i.hour5, i.hour6, i.hour7, i.hour8, i.hour9, i.hour10, i.hour11, i.hour12, i.hour13, i.hour14, i.hour15, i.hour16, i.hour17, i.hour18, i.hour19, i.hour20, i.hour21, i.hour22, i.hour23, i.totalHours]
                }),
                hourlySpreadChildYLabels: action.data.chartDataDate.map(i => i.dates),
                hourlySpreadChart: action.data.getDataDateWiseInfo.map(value => ({
                    id: value.dates, userID: value.userID, applicationname: value.applicationname, time: value.time, timeSpent: value.timeSpent,isProductive:value.isProductive
                })),
                hourlySpreadBarChart: action.data.getDataDateWiseInfoProdUnProd,
                isLoadingHourlySpreadChild: false,
            }
        case types.FAILED_HOURLY_SPREAD_CHILD:
            return {
                ...state,
                hourlySpreadChild: [],
                isLoadingHourlySpreadChild: false
            }

        case types.FETCH_HOURLY_SPREAD_CHILD:
            return {
                ...state,
                isLoadingHourlySpreadChild: true
            }
        case types.SUCCESS_TOP_PRODUCTIVE:
            return {
                ...state,
                topProductive: action.data.map(i => ({
                    date: i.userName, Productive: i.prodHour, Unproductive: i.totalHour, IdleTime: i.idleHour,
                })),
                isLoadingTopProductive: false
            }
        case types.FAILED_TOP_PRODUCTIVE:
            return {
                ...state,
                topProductive: [],
                isLoadingTopProductive: false
            }
        case types.SUCCESS_LEAST_PRODUCTIVE:
            return {
                ...state,
                leastProductive: action.data.map(i => ({
                    date: i.userName, Productive: i.prodHour, Unproductive: i.totalHour, IdleTime: i.idleHour,
                })),
                isLoadingLeastProductive: false,
            }
        case types.FAILED_LEAST_PRODUCTIVE:
            return {
                ...state,
                leastProductive: [],
                isLoadingLeastProductive: false
            }

        case types.SUCCESS_UTILIZATION:
            return {
                ...state,
                utilization: action.data.map(i => ({ date: i.date, Target: i.target, WorkTime: i.workTime,Holiday:i.holiday })),
                isLoadingUtilization: false,
            }
        case types.FAILED_UTILIZATION:
            return {
                ...state,
                utilization: [],
                isLoadingUtilization: false,
            }
        case types.SUCCESS_ATTENDANCE_HEATMAP_CHILD:
            return {
                ...state,
                attendanceHeatMapChild: action.data.getAttendanceDataTeam
                    .map(value => [parseInt(value.date1), parseInt(value.date2), parseInt(value.date3), parseInt(value.date4), parseInt(value.date5), parseInt(value.date6), parseInt(value.date7), parseInt(value.date8), parseInt(value.date9), parseInt(value.date10),
                    parseInt(value.date11), parseInt(value.date12), parseInt(value.date13), parseInt(value.date14), parseInt(value.date15), parseInt(value.date16), parseInt(value.date17), parseInt(value.date18), parseInt(value.date19), parseInt(value.date20),
                    parseInt(value.date21), parseInt(value.date22), parseInt(value.date23), parseInt(value.date24), parseInt(value.date25), parseInt(value.date26), parseInt(value.date27), parseInt(value.date28), parseInt(value.date29), parseInt(value.date30), parseInt(value.date31)
                    ]),
                attendanceHeatMapYLabels: action.data.getAttendanceDataTeam.map(i => i.team),
                isLoadingAttendanceHeatMapChild: false,
                attendanceHeatMapChart: action.data.getAttendanceDataTeamwiseUserInfo,
                attentanceExpendableHeatmapChart: action.data.getAttendanceDataTeamwiseUser,
                attendanceHeatMapLabelID: action.data.getAttendanceDataTeam.map(i => i.teamID),

            }
        case types.FETCH_ATTENDANCE_HEATMAP_CHILD:
            return {
                ...state,
                isLoadingAttendanceHeatMapChild: true,
            }
        case types.FAILED_ATTENDANCE_HEATMAP_CHILD:
            return {
                ...state,
                isLoadingAttendanceHeatMapChild: false,
            }
        case types.SHOW_LOADER_DEEP_DIVE:
            return {
                ...state,
                attendanceHeatMap: [],
                attendanceHeatMapChild: [],
                isLoadingAttendanceHeatMap: true,
                isLoadingAttendanceHeatMapChild: true,
                attendanceHeatMapXLabels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                attendanceHeatMapYLabels: [],
                attendanceHeatMapChart: [],
                attendanceHeatMapLabelID: '',
                hourlySpread: [],
                hourlySpreadChild: [],
                isLoadingHourlySpread: true,
                isLoadingHourlySpreadChild: true,
                hourlySpreadBarChart: [],
                hourlySpreadChart: [],
                hourlySpreadChildYLabels: [],
                hourlySpreadChildXLabels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, "Total Hrs"],
                topProductive: [],
                isLoadingTopProductive: true,
                leastProductive: [],
                isLoadingLeastProductive: true,
                utilization: [],
                isLoadingUtilization: true,
            }
        default:
            return state
    }
}
export default reducer
